import React from 'react';

import classNames from 'classnames';

export interface IGridProps {
    children: React.ReactNode;
    reverse?: string[];
    justify?: string[];
    align?: string[];
    equalHeight?: boolean;
    gutter?: 'default' | 'none' | 'small' | 'large';
    className?: string;
    /**
     * If grid should not wrap. Can be used with breakpoints noWrap={["xs", "sm", "md", "lg"]}
     */
    noWrap?: string[] | boolean;
    transition?: boolean;
    verticalGutter?: 'default' | 'small' | 'large' | 'none';
    /**
     * If grid should wrap in certain breakpoint wrap={["xs", "sm", "md", "lg"]}
     */
    wrap?: string[];
}

export const Grid = ({
    equalHeight,
    transition,
    gutter = 'default',
    verticalGutter,
    reverse,
    justify,
    align,
    noWrap,
    wrap,
    className,
    children,
}: IGridProps): JSX.Element => {
    const computedClassName = classNames(
        'grid',
        {
            'grid--equalheight': equalHeight,
            'grid--with-transition': transition,
            [`grid--gutter-${gutter}`]: gutter,
            [`grid--vertical-gutter-${verticalGutter}`]: verticalGutter,
        },
        reverse && reverse.map((rev) => `grid--reverse-${rev}`),
        justify && justify.map((jus) => `grid--${jus}`),
        align && align.map((alig) => `grid--${alig}`),
        noWrap && Array.isArray(noWrap) ? noWrap.map((nw) => `grid--no-wrap-${nw}`) : 'grid--no-wrap-xs',
        wrap && wrap.map((wr) => `grid--wrap-${wr}`),
        className,
    );

    return (
        <div className={computedClassName}>
            {children}
        </div>
    );
};

